/* manage different color logo on collection page having banner image */
  $('x-header').mouseenter(function () {
            if($(this).hasClass('collection_banner') && !$(this).hasClass('is-solid')){
                     console.log('white now');
                  if ($('a.header__logo').is('.transparent_logo'))
                  {
                      $('a.header__logo').removeClass('transparent_logo')
                  }
                  $('a.header__logo').html('<img src=https://cdn.shopify.com/s/files/1/0266/1774/1359/files/GDV_Logo_Horse_Above_2.png?v=1717710488" alt="" srcset="//www.graysondevere.com/cdn/shop/files/GDV_Logo_Horse_Above_2.png?v=1717710488&amp;width=520 520w, //www.graysondevere.com/cdn/shop/files/GDV_Logo_Horse_Above_2.png?v=1717710488&amp;width=780 780w" width="2000" height="1000" sizes="260px" class="header__logo-image">');
            }
          });
          $('x-header').mouseleave(function () {
            if($(this).hasClass('collection_banner') && !$(this).hasClass('is-solid')){
               console.log('grey logo');
                  if ($('a.header__logo').is('.transparent_logo')){}
                  else{
                      $('a.header__logo').addClass('transparent_logo')
                  }
                  $('a.header__logo').html('<img src="https://cdn.shopify.com/s/files/1/0266/1774/1359/files/GDV_Logo_Horse_Above_White_2.png?v=1717710491" alt="" srcset="//www.graysondevere.com/cdn/shop/files/GDV_Logo_Horse_Above_White_2.png?v=1717710491&amp;width=520 520w, //www.graysondevere.com/cdn/shop/files/GDV_Logo_Horse_Above_White_2.png?v=1717710491&amp;width=780 780w" width="2000" height="1000" sizes="260px" class="header__logo-image">');
            }
          });
/* //manage different color logo on collection page having banner image */

/*
  make the entirety of the slideshow clickable
*/
$('.slideshow__slide.is-selected').click(function(){
    var link = $(this).parent().find('a.link').attr('href');
    if(link != '' && link != 'undefined'){
    window.location.href = link;
    }
});


/*
 * Sticky header
*/
$(window).scroll(function(){
  var sticky = $('header'),
      scroll = $(window).scrollTop();
  if (scroll > 50) {
    console.log('add');
    sticky.addClass('sticky_header');
  }
  else{
    console.log('remove');
  sticky.removeClass('sticky_header');
  }
});

/*
  Slide Cart custom gift wrap options using Wrapped App
*/

//onclick 'Is this a gift'  button display gift box and popup title
jQuery(document).on("click", ".cstomGiftOpn", function () {
	cstomGiftOpn();
});


function editGiftWrappingText(){
		//var getText = jQuery('div#CstmGiftBox feature-checkbox span').text();
		var getText = jQuery('#CstmGiftBox wrapped-feature-checkbox-simple span[part="label"]').text();
		var arr 	= getText.split('signature wrapping');
		var firstRow = arr[0];
		
		var finalRow = arr[0] + '<span class="cstmbtn" onclick="displayGiftImg()">signature wrapping</span>  <span class="cstmprice_gift">? - $10</span>';
		
		//jQuery('div#CstmGiftBox feature-checkbox span').html(finalRow);
		jQuery('#CstmGiftBox wrapped-feature-checkbox-simple span[part="label"]').html(finalRow);
}


function cstomGiftOpn() {
  console.log('open gift');
  var x = document.getElementById("CstmGiftBox");
   
  if (x.style.display === "none") {
    
    x.style.display = "block";
    setTimeout(function () {
      if (jQuery('span.cstmbtn').length) {
      }
      else {
        console.log('Pepsi');
		editGiftWrappingText();
      	if(jQuery('input[type="checkbox"]').is(':checked')){
            console.log('Checkbox checked');
          jQuery('.cstomGiftOpn').text('SAVE');
         }else{
          console.log('Checkbox not checked');
          jQuery('.cstomGiftOpn').text('IS THIS A GIFT?');
         }
      }
    }, 500);
  } else {
    console.log('Hide whole gift box');
   // x.style.display = "none !important";
	jQuery('wrapped-extension').attr('style', 'display:none !important;');
    //jQuery('.cstmbtn').remove();
    //jQuery('.cstmprice_gift').remove();
    jQuery('.cstomGiftOpn').text('IS THIS A GIFT?');
  }
}
function cstomGiftOpncart() {
  //$('footer.Cart__Footer wrapped-extension').toggleClass('hideForwrap');
	$('wrapped-extension').toggleClass('hideForwrap');
}

jQuery(document).ready(function () {
  setTimeout(function () {
	  console.log('settimeout');
    // jQuery('footer.Cart__Footer .giftwrap-by-wrapped').addClass('hideForwrap');
    //jQuery('footer.Cart__Footer wrapped-extension').attr('id', 'CstmGiftBoxCart');
	jQuery('wrapped-extension').attr('id', 'CstmGiftBoxCart');
  }, 3000);
});



jQuery(document).ready(function () {
  //jQuery('.giftwrap-by-wrapped').attr('style', 'display:none;');  
  
	setInterval(function () { //triggering continuously even on removing gift item
		//jQuery('.giftwrap-by-wrapped').attr('id', 'CstmGiftBox');
		jQuery('wrapped-extension').attr('id', 'CstmGiftBox');
	}, 5);
});


$(document).on('click', '.QuantitySelector__Button', function (event) {
console.log('clicked');
 // cstomGiftOpn()
	setTimeout(function () {
		if (jQuery('span.cstmbtn').length) {
		} 
		else 
		{
			editGiftWrappingText();
			/*jQuery('<div class="signpop"><span  class="cstmbtn" onclick="displayGiftImg()">signature wrapping</span>  <span class="cstmprice_gift">? - $10</span></div>').insertAfter('div#CstmGiftBox feature-checkbox'); */
		}
	}, 3000);
});


jQuery(document).on("click", 'input[type="checkbox"]', function () {
   console.log('check clicked');  
  setTimeout(function () {
    /*
    if (jQuery('span.cstmbtn').length) {
    } else {
  	  editGiftWrappingText();
    }
    */

    if(jQuery('input[type="checkbox"]').is(':checked'))
      { 
        if (jQuery('span.cstmbtn').length) {} 
        else {
    	  editGiftWrappingText();
        }
        console.log('checked here');
        jQuery('.cstomGiftOpn').text('SAVE');
      }
    else{
        console.log('not checked');
        var x = document.getElementById("CstmGiftBox");
        x.style.display = "none";
        jQuery('.cstomGiftOpn').text('IS THIS A GIFT?');
     }
  },4000);
});


  jQuery("button.ProductForm__AddToCart.Button.Button--primary.Button--full").on('click', function () {

    setTimeout(function () {
      jQuery('wrapped-extension').attr('style', 'display:none !important;');
      jQuery('wrapped-extension').attr('id', 'CstmGiftBox');

    }, 1800);

  });

  //jQuery('a.Heading.u-h6[data-drawer-id="sidebar-cart"]').click(function () {
jQuery('a[aria-controls="cart-drawer"]').click(function () {
    setTimeout(function () {
      jQuery('wrapped-extension').attr('style', 'display:none !important;');
      jQuery('wrapped-extension').attr('id', 'CstmGiftBox');
    }, 500);

  });
  jQuery(' a.Header__Icon.Icon-Wrapper.Icon-Wrapper--clickable.hidden-desk').click(function () {

    setTimeout(function () {
      jQuery('wrapped-extension').attr('style', 'display:none !important;');
      jQuery('wrapped-extension').attr('id', 'CstmGiftBox');
    }, 500);

  });
  
  
function displayGiftImg() {
 $(".popup-overlay_giftimg, .popup-content_giftimg").addClass("active");
}

function cstomGiftclose() {
$(".popup-overlay_giftimg, .popup-content_giftimg").removeClass("active");
}


